import { AbstractFormatPropertyAlert } from "./AbstractFormatPropertyAlert";

export class FormatPropertyEmptyAlert extends AbstractFormatPropertyAlert {
  constructor(propertyKind: string, isError: boolean) {
    super(propertyKind, isError);
  }

  get description(): string {
    return "入力されていません。";
  }
}
